import { ActivityStatus } from './../../../../../models/activities/activity';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { Component, OnInit } from '@angular/core';
import { CallWorkflowActivity } from 'src/app/models/activities/call-workflow-activity';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutService } from 'src/app/services/layout.service';
import { WorkflowContextService } from 'src/app/services';
import { WorkflowApplicationsJanusService } from 'src/app/views/admin/workflow-applications/workflow-applications-janus/workflow-applications-janus.service';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { applicantHomeRoutesNames } from 'src/app/services/mock-data/applicant-home-constants/applicant-home-constants';

@Component({
  selector: 'wm-call-workflow-input',
  templateUrl: './call-workflow-input.component.html',
  styleUrls: ['./call-workflow-input.component.css'],
  standalone: false
})
export class CallWorkflowInputComponent extends ActivityView implements OnInit {
  callActivity: CallWorkflowActivity;
  summaryViewBGJanus: boolean = true;
  templateForPermitForm: boolean = false;
  showSummary: boolean = false;
  allowReopenChildInspectionApplicationsParentActivityId: string | null = null;
  constructor(
    public layoutService: LayoutService,
    public context: WorkflowContextService,
    public router: Router,
    public route: ActivatedRoute,
    public workflowApplicationsJanusSvc: WorkflowApplicationsJanusService
  ) {
    super();
    layoutService.useNewLayout$.subscribe(useNewLayout => {
      this.templateForPermitForm = useNewLayout;
    });
  }
  ActivityStatus = ActivityStatus;
  isApplicantMobileView: boolean = false; // Code added by Sanchit on 09/22/2026
  launchWorkflowApplicationModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'You are opening related application',
    modalSubDescp:
      'The related application must be completed to finalize the original application',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default',
    customCloseAccepted: true
  };

  handlelaunchWorkflowApplicationModalAccepted() {
    // Added by Amisha on 2026-07-24.
    // Reason: close the shared confirmation modal before Renewals switches to the child workflow in the same inline view.
    if (this.router.url.includes('renewals')) {
      this.launchWorkflowApplicationModalData = {
        ...this.launchWorkflowApplicationModalData,
        open: false
      };
    }
    this.context.isJanusChildWorkflowCalled$.emit(true);
    const startingActivityId = '1';
    if (
      this.context.janusLayout === 'staff' &&
      this.router.url.includes('workflow-applications')
    ) {
      if (this.context.applicationViewType === 'overlay') {
        this.router.navigate(
          [
            'admin',
            'jurisdiction',
            this.context.client.id,
            'department',
            this.context.staffDepartmentId,
            'workflow-applications',
            'data',
            'child-application',
            this.callActivity.model.callingWorkflowApplicationId
          ],
          {
            state: {
              startingActivityId,
              useNewLayout: this.context?.useNewLayout || false
            }
          }
        );
      } else if (this.context.applicationViewType === 'inline') {
        const currentId = this.route.snapshot.queryParamMap.get('id');
        const currentPage = this.route.snapshot.queryParamMap.get('p');
        const source = this.route.snapshot.queryParamMap.get('s');
        this.router.navigate(
          [
            'admin',
            'jurisdiction',
            this.context.client.id,
            'department',
            this.context.staffDepartmentId,
            'workflow-applications',
            'data'
          ],
          {
            queryParams: {
              p: currentPage,
              s: source
            },
            queryParamsHandling: 'replace'
          }
        );

        setTimeout(() => {
          this.router.navigate(
            [
              'admin',
              'jurisdiction',
              this.context.client.id,
              'department',
              this.context.staffDepartmentId,
              'workflow-applications',
              'data'
            ],
            {
              queryParams: {
                id: currentId,
                p: currentPage,
                isChild: 1,
                cid: this.callActivity.model.callingWorkflowApplicationId,
                s: source
              },
              queryParamsHandling: 'replace'
            }
          );
          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            scrollToExpandedRow: true
          });
        }, 500);
      }
      // Added by Amisha on 2026-07-24.
      // Reason: open the Renewals child workflow in place so the existing inline table expansion remains open.
    } else if (
      this.context.janusLayout === 'staff' &&
      this.router.url.includes('renewals')
    ) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          isChild: 1,
          cid: this.callActivity.model.callingWorkflowApplicationId,
          showAppView: 1
        },
        queryParamsHandling: 'merge'
      });
    } else if (this.context.janusLayout === 'applicant') {
      const urlSegments = this.router.url.split('/');

      const isApplicationRoute = urlSegments.includes(
        applicantHomeRoutesNames.application.route
      );

      const lastRoute = isApplicationRoute
        ? applicantHomeRoutesNames.applyForPermit.route
        : applicantHomeRoutesNames.myApplications.route;
      const deptIndex = urlSegments.indexOf('department');
      const deptId = deptIndex !== -1 ? urlSegments[deptIndex + 1] : null;

      if (isApplicationRoute && deptId) {
        this.router.navigate(
          [
            '/jurisdiction',
            this.context.client.id,
            applicantHomeRoutesNames.root,
            lastRoute,
            'department',
            deptId,
            'child-application',
            this.callActivity.model.callingWorkflowApplicationId
          ],
          {
            queryParamsHandling: 'preserve'
          }
        );
      } else {
        this.router.navigate(
          [
            '/jurisdiction',
            this.context.client.id,
            applicantHomeRoutesNames.root,
            lastRoute,
            'child-application',
            this.callActivity.model.callingWorkflowApplicationId
          ],
          {
            state: {
              queryParamsHandling: 'preserve',
              startingActivityId,
              useNewLayout: this.context?.useNewLayout || false
            }
          }
        );
      }
      setTimeout(() => {
        this.disableSummaryInteractions();
      }, 0);
    }
  }
  private disableSummaryInteractions(): void {
    const cards = document.querySelectorAll('.hover-summary-card');
    cards.forEach((el: any) => {
      el.style.pointerEvents = 'none';
    });

    const footers = document.querySelectorAll(
      '.alert-summary-footer wm-common-button'
    );
    footers.forEach((el: any) => {
      el.style.setProperty(
        '--button-font-color',
        'rgba(153,153,153,0.4)',
        'important'
      );
      el.style.pointerEvents = 'none';
    });
  }
  handlelaunchWorkflowApplicationModalRejected() {
    this.launchWorkflowApplicationModalData = {
      ...this.launchWorkflowApplicationModalData,
      open: false
    };
  }

  launchChild() {
    if (this.callActivity.model.callingWorkflowApplicationId) {
      if (this.templateForPermitForm === true) {
        this.launchWorkflowApplicationModalData = {
          ...this.launchWorkflowApplicationModalData,
          open: true
        };
      } else {
        this.switchApplication.emit(
          this.callActivity.model.callingWorkflowApplicationId
        );
      }
    }
  }
  launchChildSummary() {
    if (
      this.showSummary === false &&
      this.callActivity.model.callingWorkflowApplicationId
    ) {
      this.showSummary = true;
    }
  }

  ngOnInit() {
    this.workflowApplicationsJanusSvc.data$.subscribe(data => {
      if (data.inlineApplicationSummaryDetails.categoriesDefined) {
        this.summaryViewBGJanus = false;
      }
    });
    this.callActivity = this.activity as CallWorkflowActivity;
    if (
      this.router.url.includes('workflow-applications') &&
      this.context.applicationViewType === 'inline' &&
      this.workflowApplicationsJanusSvc.getData()
        .inlineApplicationSummaryDetails?.categoriesDefined === true &&
      this.route.snapshot.queryParamMap.get('c') !== 'view-application'
    ) {
      this.allowReopenChildInspectionApplicationsParentActivityId = this.activity.id;
    } else {
      this.allowReopenChildInspectionApplicationsParentActivityId = null;
    }
  }
}
